import React, { useState } from 'react'
import { Modal, Form, Input, Button, InputNumber } from 'antd'

const GenerateCommissionsModal = (props) => {
    const { visible, handleCancel, handleGenerate, isSubmit } = props
    const [form] = Form.useForm()
    
    const onFinish = (values) => {
        handleGenerate(values.contractId)
    }
    
    const onCancel = () => {
        form.resetFields()
        handleCancel()
    }
    
    return (
        <Modal
            visible={visible}
            title="Gerar Comissões Manualmente"
            onCancel={onCancel}
            centered
            footer={[
                <Button key="back" onClick={onCancel}>
                    Cancelar
                </Button>,
                <Button 
                    key="submit" 
                    type="primary" 
                    onClick={() => form.submit()} 
                    loading={isSubmit}
                >
                    Gerar Comissões
                </Button>,
            ]}
        >
            <div className="deny-info-wrapper">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="contractId"
                        label="ID do Contrato"
                        rules={[
                            {
                                required: true,
                                message: 'Por favor, informe o ID do contrato',
                            },
                        ]}
                    >
                        <InputNumber 
                            min={1}
                            placeholder="Informe o ID do contrato"
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                    
                    <p>
                        Esta ação irá gerar comissões para todos os referenciadores 
                        associados ao contrato informado. As comissões geradas terão status "pendente" 
                        e precisarão ser aprovadas manualmente.
                    </p>
                </Form>
            </div>
        </Modal>
    )
}

export default GenerateCommissionsModal 